import { createListenerMiddleware } from '@reduxjs/toolkit'
import { toast } from 'sonner'
import { MessageType } from '@axilon-apps/libs-ui-constants'
import { feedbackMessagesToastShow } from '@axilon-apps/libs-ui-components'

// Surfaces `feedbackMessagesToastShow` actions as sonner toasts. The identity
// domain's base-query dispatches this action on server errors; without a
// listener those toasts are silently dropped. Mirrors
// `domains/axilon-devops/src/state/listeners/flash-message/flash-message-listener.ts`.
const flashMessageListener = createListenerMiddleware()

flashMessageListener.startListening({
  actionCreator: feedbackMessagesToastShow,
  effect: (action) => {
    toastByMessageTypeMap[action.payload.type](action.payload.message)
  }
})

const toastByMessageTypeMap: Record<
  MessageType,
  | typeof toast.success
  | typeof toast.error
  | typeof toast.message
  | typeof toast.info
  | typeof toast.warning
> = {
  [MessageType.Success]: toast.success,
  [MessageType.Error]: toast.error,
  [MessageType.Info]: toast.info,
  [MessageType.Warning]: toast.warning,
  [MessageType.Message]: toast.message
}

export default flashMessageListener
